import React, { useEffect, useState } from 'react'
import { HeaderMain } from '../responsiveHeader/HeaderMain'
import { AccountMenu } from './Overview-sectors/AccountMenu'
import { AccountInfo } from './Overview-sectors/AccountInfo'
import { AccountKitShipping } from './Overview-sectors/AccountKitShipping'
import { AccountSubscription } from './Overview-sectors/AccountSubscription'
import { AccountMoreInfo } from './Overview-sectors/AccountMoreInfo'
import logger from '../../../../utils/logger'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { UseGetMemberById } from '../../../../hooks/DataTable-hooks/UseGetMemberById'
import { MemberStatesMapping } from '../../../Routes/MemberManagement/MemberStateModel'


export const AccountOverview = () => {

    const { UserId } = useParams()

    //? Obtiene la Informacion de un usuario en especifico para el contenido del Modal MEMBERSHIP
    const { memberDataById, handleMemberId } = UseGetMemberById()

    useEffect(() => {

        handleMemberId(UserId)

    }, [UserId])


    const navigate = useNavigate();
    const [clickedBtn, setClickedBtn] = useState(1)


    const functionBtn = (e) => {
        const selectedBtn = Number(e.currentTarget.dataset.id)

        setClickedBtn(selectedBtn)

        if (selectedBtn === clickedBtn) {
            // logger.info('mismo boton clickeado')
            navigate('/Member')
            return
        }
    }


    const accountContent = () => {
        switch (clickedBtn) {
            case 1:

                return <AccountMenu
                    functionBtn={functionBtn}
                    
                />
            case 2:

                return <AccountInfo
                    functionBtn={functionBtn}
                    memberData={memberDataById.data}
                />
            case 3:

                return <AccountKitShipping
                    functionBtn={functionBtn}
                    memberData={memberDataById.data}
                />
            case 4:

                return <AccountSubscription
                    functionBtn={functionBtn}
                    memberData={memberDataById.data}
                    stateModel={MemberStatesMapping}
                />
            case 5:

                return <AccountMoreInfo
                    functionBtn={functionBtn}
                    memberData={memberDataById.data}
                />

            default:
                return <div></div>
        }
    }

    return (
        <div className='modal-page'>

            <div className="turn-back">


                <Link className="mp-a-back " to={''} onClick={(e) => e.preventDefault()}>
                    <span
                        className="material-symbols-outlined mI-arrow-back mp-mI-back notranslate"
                        aria-hidden="true"
                        role="none"
                        data-id='1'
                        onClick={functionBtn}>
                        arrow_back
                    </span>
                </Link>



                <p className="mp-userName">{`${memberDataById.data?.lastname} ${memberDataById.data?.name}`}</p>
            </div>



            <div className="modal-page-data">

                {accountContent()}

            </div>

            <HeaderMain />
        </div>
    )
}
